import { addDays, isAfter, parseISO } from 'date-fns'
import { defineStore } from 'pinia'

const COUPON_EXPIRATION_IN_DAYS = 7

export const useHypeStore = defineStore(
  'ltc_hype',
  () => {
    const couponCode = ref<Maybe<string>>(null)
    const couponDate = ref<Maybe<string>>(null)
    const couponSeen = ref(false)
    const couponSubmitPending = ref(false)

    const deleteCoupon = () => {
      couponCode.value = null
      couponDate.value = null
      couponSeen.value = false
      couponSubmitPending.value = false
    }

    const setCoupon = (newCoupon: string, { tracksSubmit = false } = {}) => {
      if (tracksSubmit) couponSubmitPending.value = true
      else if (newCoupon !== couponCode.value) couponSubmitPending.value = false

      couponCode.value = newCoupon
      couponDate.value = new Date().toISOString()
      couponSeen.value = false
    }

    const setCouponSubmitPending = (isPending: boolean) => {
      couponSubmitPending.value = isPending
    }

    const setCouponSeen = (isSeen: boolean) => {
      couponSeen.value = isSeen
    }

    const checkCouponExpiration = () => {
      if (!couponDate.value) return

      const expirationDate = addDays(new Date(), COUPON_EXPIRATION_IN_DAYS)

      if (isAfter(parseISO(couponDate.value), expirationDate)) {
        deleteCoupon()
      }
    }

    onBeforeMount(() => {
      checkCouponExpiration()
    })

    return {
      checkCouponExpiration,
      couponCode,
      couponDate,
      couponSeen,
      couponSubmitPending,
      deleteCoupon,
      setCoupon,
      setCouponSeen,
      setCouponSubmitPending,
    }
  },
  {
    persist: {
      storage: piniaPluginPersistedstate.localStorage(),
    },
  },
)
